import { TaxonomyFormPage } from '../taxonomy/TaxonomyFormPage.js';

export function CarModelFormPage() {
  return (
    <TaxonomyFormPage
      config={{
        title: 'Model',
        apiPath: '/car-models',
        basePath: '/car-models',
        resource: 'carModel',
        fields: [
          {
            name: 'brand_id',
            label: 'Brand',
            type: 'select',
            required: true,
            optionsQuery: { resource: 'carBrand', apiPath: '/car-brands' },
          },
        ],
      }}
    />
  );
}
